module.exports = __webpack_public_path__ + "static/media/2_hall_outdoors_rear.a18a294e.jpg";